import apiBase from "./api-base";
export default class Diner extends apiBase {
    constructor (store) {
        const path = 'Diner'
        super(store, path)
    }
    UpdateOrderRebrandlyPaymentURL (model) {
        return this._request({
            action: 'UpdateOrderRebrandlyPaymentURL',
            method: 'POST',
            body: model
        })
    }
    SendPaymentURL (model) {
        return this._request({
            action: 'SendPaymentURL',
            method: 'POST',
            body: model
        })
    }

    UpdateOrderPickupTime (model) {
        return this._request({
            action: 'UpdateOrderPickupTime',
            method: 'POST',
            body: model
        })
    }
    UpdateOrderTip (model) {
        return this._request({
            action: 'UpdateOrderTip',
            method: 'POST',
            body: model
        })
    }
}
